import { queryString } from './queryString';

export function trySetApiKey() {
    const apiKey = queryString('apiKey');
    if(!apiKey || apiKey === '') {
        return;
    }
    setApiKey(apiKey);
}

export function getApiKey() {
    const apiKey = localStorage.getItem('tirehotelapikey');
    return apiKey;
}

function setApiKey(apiKey) {
    localStorage.setItem('tirehotelapikey', apiKey);
}